import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loader from "./view/components/common/loader";

const Home = lazy(() =>
  import("./view/pages/Home" /* webpackChunkName: "home" */)
);

const Agenciess = lazy(() =>
  import("./view/pages/agency/index" /* webpackChunkName: "agencies" */)
);

const ComposeAgency = lazy(() =>
  import("./view/pages/agency/compose" /* webpackChunkName: "compose_agency" */)
);

const Advertising = lazy(() =>
  import(
    "./view/pages/advertising/index" /* webpackChunkName: "advertisings" */
  )
);

const ManageAdvertising = lazy(() =>
  import(
    "./view/pages/advertising/manage" /* webpackChunkName: "manage_advertising" */
  )
);


const ManageFreeAdvertising = lazy(() =>
  import(
    "./view/pages/advertising/manage_free" /* webpackChunkName: "manage_free_advertising" */
  )
);

const ManageRequestAdvertising = lazy(() =>
  import(
    "./view/pages/advertising/manage_request"
  )
);


const Admins = lazy(() =>
  import("./view/pages/sub_admins/index" /* webpackChunkName: "admins" */)
);

const ComposeAdmins = lazy(() =>
  import(
    "./view/pages/sub_admins/compose" /* webpackChunkName: "compose_admin" */
  )
);

const Supervisors = lazy(() =>
  import("./view/pages/supervisor/index" /* webpackChunkName: "supervisors" */)
);

const SupervisorDetails = lazy(() =>
  import(
    "./view/pages/supervisor/details" /* webpackChunkName: "supervisor_details" */
  )
);

const Consultants = lazy(() =>
  import("./view/pages/consultant/index" /* webpackChunkName: "consultants" */)
);

const ConsultantDetails = lazy(() =>
  import(
    "./view/pages/consultant/details" /* webpackChunkName: "consultant_details" */
  )
);

const Customers = lazy(() =>
  import("./view/pages/customer/index" /* webpackChunkName: "customers" */)
);

const CustomerDetails = lazy(() =>
  import(
    "./view/pages/customer/details" /* webpackChunkName: "customer_details" */
  )
);

const Blogs = lazy(() =>
  import("./view/pages/editor/blogs/blog/index" /* webpackChunkName: "blogs" */)
);

const ComposeBlog = lazy(() =>
  import(
    "./view/pages/editor/blogs/blog/compose" /* webpackChunkName: "compose_blog" */
  )
);

const BlogCategories = lazy(() =>
  import(
    "./view/pages/editor/blogs/category/index" /* webpackChunkName: "blog_categories" */
  )
);

const ComposeBlogCategory = lazy(() =>
  import(
    "./view/pages/editor/blogs/category/compose" /* webpackChunkName: "compose_blog_category" */
  )
);

const Processes = lazy(() =>
  import("./view/pages/process/index" /* webpackChunkName: "processes" */)
);

const ManageProcess = lazy(() =>
  import(
    "./view/pages/process/details" /* webpackChunkName: "manage_process" */
  )
);

const Checkouts = lazy(() =>
  import("./view/pages/checkout/index" /* webpackChunkName: "checkouts" */)
);

const CheckoutAgencies = lazy(() =>
  import(
    "./view/pages/checkout/agency" /* webpackChunkName: "checkout_agencies" */
  )
);

const CheckoutSupervisors = lazy(() =>
  import(
    "./view/pages/checkout/supervisors" /* webpackChunkName: "checkout_supervisors" */
  )
);

const CheckoutConsultans = lazy(() =>
  import(
    "./view/pages/checkout/consultans" /* webpackChunkName: "checkout_consultants" */
  )
);

const CheckoutDetails = lazy(() =>
  import(
    "./view/pages/checkout/details" /* webpackChunkName: "checkout_details" */
  )
);

const FreeAdvertising = lazy(() =>
  import(
    "./view/pages/advertising/free" /* webpackChunkName: "free_advertisings" */
  )
);

const RequestAdvertising = lazy(() =>
  import(
    "./view/pages/advertising/request" /* webpackChunkName: "free_advertisings" */
  )
);

const ArchivedAdvertising = lazy(() =>
  import(
    "./view/pages/advertising/archived" /* webpackChunkName: "archived_advertisings" */
  )
);

const ConsultationReqeusts = lazy(() =>
  import(
    "./view/pages/consultation_request/index" /* webpackChunkName: "consultation_request" */
  )
);

const ComposeCustomer = lazy(() =>
  import(
    "./view/pages/customer/compose" /* webpackChunkName: "consultant_compose_customer" */
  )
);

export default function AdminPage() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/agencies" element={<Agenciess />} />
        <Route path="/compose-agency/:id" element={<ComposeAgency />} />
        <Route path="/advertising/:state?" element={<Advertising />} />
        <Route path="/manage-advertising/:id" element={<ManageAdvertising />} />
        <Route path="/manage-free-advertising/:id" element={<ManageFreeAdvertising />} />
        <Route path="/manage-request-advertising/:id" element={<ManageRequestAdvertising />} />
        <Route path="/admins" element={<Admins />} />
        <Route path="/compose-admin/:id" element={<ComposeAdmins />} />
        <Route path="/supervisors" element={<Supervisors />} />
        <Route path="/supervisor-details/:id" element={<SupervisorDetails />} />
        <Route path="/consultants" element={<Consultants />} />
        <Route path="/consultant-details/:id" element={<ConsultantDetails />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customer-details/:id" element={<CustomerDetails />} />
        <Route path="/compose-customer/:id" element={<ComposeCustomer />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/compose-blog/:id" element={<ComposeBlog />} />
        <Route path="/blog-categories" element={<BlogCategories />} />
        <Route
          path="/compose-blog-category/:id"
          element={<ComposeBlogCategory />}
        />
        <Route path="/processes" element={<Processes />} />
        <Route path="/manage-process/:id" element={<ManageProcess />} />
        <Route path="/checkouts" element={<Checkouts />} />
        <Route path="/checkout-agencies/:id" element={<CheckoutAgencies />} />
        <Route
          path="/checkout-supervisors/:id/:agency"
          element={<CheckoutSupervisors />}
        />
        <Route
          path="/checkout-consultants/:id/:supervisor"
          element={<CheckoutConsultans />}
        />
        <Route path="/factor-details/:id" element={<CheckoutDetails />} />
        <Route path="/free-advertising/:state?" element={<FreeAdvertising />} />
        <Route path="/request-advertising/:state?" element={<RequestAdvertising />} />
        <Route path="/archived-advertising" element={<ArchivedAdvertising />} />
        <Route path="/consultation-requests" element={<ConsultationReqeusts />} />

        <Route path="*" element={<Navigate to={"/admin/auth/login"} />} />
      </Routes>
    </Suspense>
  );
}
